export default function (props: any) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <rect x="2" y="8" width="20" height="13" rx="1" fill="#5377EA" />
            <rect x="3" y="3" width="18" height="12" rx="1" fill="#EAEFFC" />
            <g filter="url(#filter0_d_6059_103)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M2.55487 20.2953C2.22586 20.1315 1.9998 19.7919 1.9998 19.3995L1.9998 9L2.3794 9L9.81711 14.4198C10.0636 14.5994 10.0636 14.8238 9.81711 15.0034L2.55487 20.2953Z"
                    fill="url(#paint0_linear_6059_103)"
                />
            </g>
            <g filter="url(#filter1_d_6059_103)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M21.4471 20.2953C21.7761 20.1315 22.0022 19.7919 22.0022 19.3995L22.0021 9L21.6226 9L14.1848 14.4198C13.9384 14.5994 13.9384 14.8238 14.1848 15.0034L21.4471 20.2953Z"
                    fill="url(#paint1_linear_6059_103)"
                />
            </g>
            <g filter="url(#filter2_d_6059_103)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M22 18.9918V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V19.0164L11.5057 13.309C11.8226 13.1188 12.2185 13.1188 12.5353 13.309L22 18.9918Z"
                    fill="url(#paint2_linear_6059_103)"
                />
            </g>
            <line x1="7" y1="6.5" x2="17" y2="6.5" stroke="#C6CFE7" />
            <line x1="7" y1="9.5" x2="17" y2="9.5" stroke="#C6CFE7" />
            <defs>
                <filter id="filter0_d_6059_103" x="1.2" y="7.2" width="9.60195" height="13.0953" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset dy="-1" />
                    <feGaussianBlur stdDeviation="0.4" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_6059_103" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_6059_103" result="shape" />
                </filter>
                <filter id="filter1_d_6059_103" x="13.2" y="7.2" width="9.60195" height="13.0953" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset dy="-1" />
                    <feGaussianBlur stdDeviation="0.4" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_6059_103" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_6059_103" result="shape" />
                </filter>
                <filter id="filter2_d_6059_103" x="1" y="12.1664" width="22" height="9.83359" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset />
                    <feGaussianBlur stdDeviation="0.5" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0.0969259 0 0 0 0 0.604818 0 0 0 0.4 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_6059_103" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_6059_103" result="shape" />
                </filter>
                <linearGradient id="paint0_linear_6059_103" x1="12.2055" y1="14.6428" x2="1.99931" y2="14.6428" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#96AEFF" />
                    <stop offset="0.71219" stopColor="#5C7BE9" />
                    <stop offset="1" stopColor="#526DDC" />
                </linearGradient>
                <linearGradient id="paint1_linear_6059_103" x1="11.7965" y1="14.6428" x2="22.0026" y2="14.6428" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#96AEFF" />
                    <stop offset="0.71219" stopColor="#5C7BE9" />
                    <stop offset="1" stopColor="#526DDC" />
                </linearGradient>
                <linearGradient id="paint2_linear_6059_103" x1="12" y1="13.1664" x2="12" y2="21" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#96AEFF" />
                    <stop offset="0.71219" stopColor="#5C7BE9" />
                    <stop offset="1" stopColor="#526DDC" />
                </linearGradient>
            </defs>
        </svg>
    );
}
